import { forwardRef, useEffect, useState } from 'react';

import arrow from '../../assets/arrow.svg';
import {
  CardContainer,
  ChatContactContainer,
  ChatContainerDetail,
  ContactCode,
  ContactCodeTipsText,
  ContactIcon,
  ContactIconContainer,
  ContactName,
  ContactOpenButton,
  CustomerContainer,
  GoToButton,
  HistoryIcon,
  HistoryItem,
  HistoryMessageWrapper,
  HistoryText,
  HistoryTime,
  NewSessionContainer,
  SubTitle,
  Title,
  TitleContainer,
  TitleText,
} from './styled';

import email from '../../assets/email.svg';
import whatsapp from '../../assets/whatsapp.svg';

// 客户图标
import customer from '../../assets/user.svg';
import { channelState, containerState, messageDateType, messageRole } from '../../constant';

import { QRCode } from 'antd';
const agent = (color = '#3463FC') => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1199_12716)">
      <circle cx="10" cy="10" r="10" fill="white" />
      <path
        d="M10 0C15.523 0 20 4.47696 20 10C20 15.523 15.523 20 10 20C4.47696 20 0 15.523 0 10C0 4.47696 4.47696 0 10 0ZM9.97783 4.41261C7.28217 4.41261 5.08956 6.64478 5.08956 9.40826C5.08956 9.43087 5.0913 9.45304 5.09391 9.47522C5.08957 9.51087 5.08956 9.54739 5.08956 9.58391V10.9874C5.05217 11.7222 5.64348 12.3478 6.41435 12.3887H6.74565C7.51783 12.3483 8.11 11.7213 8.07174 10.9857V9.58348C8.10956 8.8487 7.51826 8.22261 6.74739 8.1813H6.41565C6.36844 8.18125 6.32126 8.18386 6.27435 8.18913C6.62435 6.91348 7.67 5.91696 9.00913 5.58304C11.0552 5.07304 13.1474 6.23957 13.683 8.18913C13.6358 8.18383 13.5884 8.18122 13.5409 8.1813H13.2096C12.4378 8.2213 11.8457 8.84826 11.8835 9.58348V10.9878C11.8452 11.723 12.4378 12.3504 13.2096 12.3904H13.4539C13.0638 13.0909 12.4534 13.6431 11.7174 13.9613C11.6277 13.8689 11.5146 13.8025 11.3903 13.7691C11.2659 13.7356 11.1348 13.7364 11.0109 13.7713L10.05 14.0435C9.64 14.187 9.41348 14.6061 9.52826 15.0078L9.53826 15.05C9.63652 15.4287 10.0383 15.6604 10.4365 15.5665L11.397 15.2943C11.7057 15.1952 11.9217 14.9291 11.9448 14.6204C13.0587 14.1296 13.9152 13.2287 14.3152 12.1243C14.4883 11.9897 14.628 11.8169 14.7235 11.6195C14.8191 11.4221 14.8678 11.2054 14.8661 10.9861V9.58348L14.8617 9.47478C14.8648 9.45304 14.8661 9.43043 14.8661 9.40826C14.8661 6.64478 12.6735 4.41261 9.97783 4.41261Z"
        fill="#3463FC"
      />
      <g clipPath="url(#clip1_1199_12716)">
        <circle cx="10" cy="10" r="10" fill={color} />
        <g clipPath="url(#clip2_1199_12716)">
          <path
            d="M16.1033 8.30923C15.8092 5.14746 13.2357 2.64746 10.0004 2.64746C6.76511 2.64746 4.11805 5.14746 3.89746 8.30923C3.16217 8.60334 2.64746 9.41217 2.64746 10.2945V11.6916C2.64746 12.868 3.60334 13.8239 4.77981 13.8239H5.58864C5.88276 13.8239 6.10334 13.6033 6.10334 13.3092V8.67687C6.10334 8.38276 5.88276 8.16217 5.58864 8.16217H4.92687C5.29452 5.66217 7.35334 3.7504 10.0004 3.7504C12.5739 3.7504 14.7063 5.66217 15.0739 8.16217H14.4122C14.118 8.16217 13.8975 8.38276 13.8975 8.67687V13.2357C13.8975 13.5298 14.118 13.7504 14.4122 13.7504H14.6328C14.4122 15.0004 13.4563 15.7357 11.618 15.8828C11.471 15.6622 11.1769 15.5151 10.8828 15.5151H9.85334C9.33864 15.5151 8.97099 15.8828 8.97099 16.3975C8.97099 16.9122 9.33864 17.2798 9.85334 17.2798H10.8828C11.1769 17.2798 11.3975 17.2063 11.5445 16.9857C14.0445 16.8386 15.4416 15.7357 15.6622 13.6769C16.618 13.5298 17.3533 12.6475 17.3533 11.618V10.221C17.3533 9.41217 16.8386 8.60334 16.1033 8.30923ZM5.07393 9.41217V12.5004C5.07393 12.6475 5.0004 12.721 4.85334 12.721H4.77981C4.19158 12.721 3.7504 12.2798 3.7504 11.6916V10.2945C3.7504 9.70628 4.19158 9.26511 4.77981 9.26511H4.85334C5.0004 9.19158 5.07393 9.33864 5.07393 9.41217ZM16.3239 11.6916C16.3239 12.2798 15.8828 12.721 15.2945 12.721H15.1475C15.0004 12.721 14.9269 12.6475 14.9269 12.5004V9.41217C14.9269 9.26511 15.0004 9.19158 15.1475 9.19158H15.221C15.8092 9.19158 16.2504 9.63276 16.2504 10.221V11.6916H16.3239Z"
            fill="white"
          />
          <path
            d="M10.0007 13.8963C9.04481 13.8963 8.23598 13.5286 7.42716 12.7933C7.20657 12.5727 7.20657 12.2786 7.42716 12.058C7.64775 11.8374 7.94187 11.8374 8.16245 12.058C9.33892 13.161 10.736 13.161 11.8389 12.058C12.0595 11.8374 12.3536 11.8374 12.5742 12.058C12.7948 12.2786 12.7948 12.5727 12.5742 12.7933C11.7654 13.5286 10.9566 13.8963 10.0007 13.8963Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1199_12716">
        <rect width="20" height="20" fill="white" />
      </clipPath>
      <clipPath id="clip1_1199_12716">
        <rect width="20" height="20" fill="white" />
      </clipPath>
      <clipPath id="clip2_1199_12716">
        <rect width="14.7059" height="14.7059" fill="white" transform="translate(2.64746 2.64746)" />
      </clipPath>
    </defs>
  </svg>
);
const ChatContact = forwardRef((props, ref) => {
  // 终端，聊天配置数据、显示组件状态、按钮状态、设置按钮状态函数
  const {
    device,
    chatConfig,
    container,
    setContainer,
    setFormData,
    setMessageDataId,
    setIsHistory,
    setDisconnect,
    setChatting,
    channel,
    setChannel,
    setAgentDisabled,
    newChat,
    clearMessageCount,
  } = props;
  const [contactList, setContactList] = useState([]);

  const [historyMsgList, setHistoryMsgList] = useState([]);

  const [detailData, setDetailDate] = useState(null);

  useEffect(() => {
    // 设置联系方式列表
    if (chatConfig.openWhatsappSubscribeFlag === '1') {
      setContactList((prevContactList) => [
        ...prevContactList,
        {
          icon: whatsapp,
          name: 'WhatsApp',
          link:
            'https://api.whatsapp.com/send/?phone=' +
            chatConfig.relationWhatsappPhonenumber +
            '&text&type=phone_number&app_absent=0',
        },
      ]);
    }
    if (chatConfig.openEmailSubscribeFlag === '1') {
      setContactList((prevContactList) => [
        ...prevContactList,
        {
          icon: email,
          name: 'Email',
          link: chatConfig.relationEmailAddress,
        },
      ]);
    }

    let channelList = JSON.parse(localStorage.getItem('historySession')) || [];
    if (channelList && channelList.length !== 0) {
      let list = [];
      channelList.forEach((cItem) => {
        if (cItem.channelId === chatConfig.channelId) {
          cItem.list.forEach((item) => {
            let id = item.messageDataId;
            let isDisconnect = item.isDisconnect;
            // 只显示消息类型的最后一条
            const msgList = item.list.filter((item1) => {
              return item1.dataType === messageDateType.MESSAGE;
            });
            let length = msgList.length;
            if (length > 0) {
              let data = msgList[length - 1];
              data.hMessageId = id;
              data.isDisconnect = isDisconnect;
              list.push(data);
            }
          });
        }
      });
      list.reverse();
      setHistoryMsgList(list);
    }
  }, []);

  /**
   * 点击创建新会话
   */
  const handleClickGoToChat = () => {
    let chatOpenChannelType = chatConfig.chatOpenChannelType;

    setAgentDisabled(chatOpenChannelType === '1' || chatOpenChannelType === '3');

    //设置渠道状态，如果开启KNOWLEDGE和CONNECT
    if (chatOpenChannelType === '1' || chatOpenChannelType === '2') {
      setChannel(channelState.KNOWLEDGE);
    }
    // 如果只开启CONNECT
    else if (chatOpenChannelType === '3') {
      setChannel(channelState.CONNECT);
    }
    // 判断是否开启表单页。
    const localForm = JSON.parse(window.localStorage.getItem('goclouds-chat-form'));
    if (localForm) {
      let phoneNumber = localForm.phoneNumber;
      let userEmail = localForm.userEmail;
      let username = localForm.username;
      // 如果缓存中存在联系信息，不展示填写信息页
      if ((username && userEmail) || (username && phoneNumber)) {
        setFormData({
          chat_user_name: username,
          chat_email: userEmail,
          chat_phone_number: phoneNumber,
        });
        // setContainer(containerState.CHAT_WIDGET);// 切换至聊天
        if (chatConfig.isVideoContainer) {
          setContainer(containerState.VIDEO);
        } else {
          setContainer(containerState.CHAT_WIDGET);
        }
      } else {
        setFormData({
          chat_user_name: username,
          chat_email: userEmail,
          chat_phone_number: phoneNumber,
        });
        if (chatConfig.preChatForm.visible) {
          setContainer(containerState.FORM); // 切换至表单
        } else {
          // setContainer(containerState.CHAT_WIDGET); // 切换至聊天
          if (chatConfig.isVideoContainer) {
            setContainer(containerState.VIDEO);
          } else {
            setContainer(containerState.CHAT_WIDGET);
          }
        }
      }
    } else {
      if (chatConfig.preChatForm.visible && !chatConfig.singleChat) {
        setContainer(containerState.FORM); // 切换至表单
      } else {
        // setContainer(containerState.CHAT_WIDGET); // 切换至聊天
        if (chatConfig.isVideoContainer) {
          setContainer(containerState.VIDEO);
        } else {
          setContainer(containerState.CHAT_WIDGET);
        }
      }
    }
  };
  if (newChat) {
    handleClickGoToChat();
  }
  /**
   * 点击历史消息
   * @param item
   */
  const handleClickHistory = (item) => {
    clearMessageCount();
    // 设置是否是聊天中状态
    setChatting(false);
    // 设置历史消息id
    setMessageDataId(item.hMessageId);
    let channelTemp = channelState.KNOWLEDGE;

    if (item.isDisconnect) {
      setIsHistory(true);
    } else {
      // 设置聊天没有结束
      setDisconnect(false);
      const channelList = JSON.parse(localStorage.getItem('historySession')) || [];
      const foundItem = channelList.find((cItem) => cItem.channelId === chatConfig.channelId);
      if (foundItem) {
        const messageItem = foundItem.list.find((item1) => item1.messageDataId === item.hMessageId);
        // 如果 session 不为空
        if (messageItem.imChatSessionId) {
          channelTemp = channelState.IM_CHAT;
        } else if (messageItem.connectChatSession) {
          channelTemp = channelState.CONNECT;
        }
      }
    }
    // 添加用户信息，名称和邮箱
    setFormData({
      chat_user_name: item.chatUserName,
      chat_email: item.chatEmail,
      chat_phone_number: item.chatPhoneNumber,
    });
    setChannel(channelTemp);
    setContainer(containerState.CHAT_WIDGET);
  };

  /**
   * 点击其他方式进行详情页
   */
  const handleClickContact = (value) => {
    if (value.name === 'Email') {
      // let mailtoLink = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      let mailtoLink = `mailto:${value.link}`;
      window.location.href = mailtoLink;
      return;
    }
    setDetailDate(value);
    setContainer(containerState.CONTACT_DETAIL);
  };

  // 点击打开连接
  const handleClickContactButton = () => {
    if (detailData === undefined || detailData === null) {
      return;
    }
    window.open(detailData.link);
  };

  function contactContent() {
    return (
      <ChatContactContainer $themeColor={chatConfig.chatThemeColor}>
        <TitleText>{chatConfig.homepageWelcomeMsg}</TitleText>
        {historyMsgList.length > 0 ? (
          <CardContainer style={{ maxHeight: contactList > 0 ? 'calc(100% - 140px)' : 'calc(100% - 240px)' }}>
            <TitleContainer>
              <Title>{chatConfig.homepageRecentSession}</Title>
              <NewSessionContainer
                onClick={handleClickGoToChat}
                $themeColor={chatConfig.chatThemeColor}
                $chatservicecolor={chatConfig.chatServiceColor}
              >
                {Plus(chatConfig.chatThemeColor)}
                <span>{chatConfig.createNewChatMsg}</span>
              </NewSessionContainer>
            </TitleContainer>
            {historyMsgList.map((item, index, array) => {
              return (
                <HistoryItem key={index}>
                  <HistoryIcon>
                    {item.role === messageRole.CUSTOMER ? (
                      <img src={customer} alt="" />
                    ) : (
                      agent(chatConfig.chatThemeColor)
                    )}
                  </HistoryIcon>
                  <HistoryMessageWrapper>
                    <HistoryTime>{item.time}</HistoryTime>
                    <HistoryText>{JSON.stringify(item.content) || item.fileUrl}</HistoryText>
                  </HistoryMessageWrapper>
                  <GoToButton
                    onClick={() => {
                      handleClickHistory(item);
                    }}
                    $themeColor={chatConfig.chatThemeColor}
                  >
                    <img src={arrow} alt="" />
                  </GoToButton>
                </HistoryItem>
              );
            })}
          </CardContainer>
        ) : (
          <CardContainer>
            <CustomerContainer>
              <div style={{ width: '85%' }}>
                <TitleContainer>
                  <Title>{chatConfig.homepageChatTitle}</Title>
                </TitleContainer>
                <SubTitle>{chatConfig.homepageChatSubtitle}</SubTitle>
              </div>
              <GoToButton
                onClick={() => {
                  handleClickGoToChat();
                }}
                $themeColor={chatConfig.chatThemeColor}
              >
                <img src={arrow} alt="" />
              </GoToButton>
            </CustomerContainer>
          </CardContainer>
        )}
        {contactList.length > 0 ? (
          <CardContainer>
            <TitleContainer>
              <Title>{chatConfig.homepageOtherContact}</Title>
            </TitleContainer>
            <ContactIconContainer>
              {contactList.map((item, index) => {
                return (
                  <img
                    onClick={() => {
                      handleClickContact(item);
                    }}
                    style={{ marginRight: '15px' }}
                    src={item.icon}
                    alt={item.name}
                    key={index}
                  />
                );
              })}
            </ContactIconContainer>
          </CardContainer>
        ) : (
          ''
        )}
      </ChatContactContainer>
    );
  }

  function contactDetailContent() {
    return (
      <ChatContainerDetail>
        <ContactIcon>
          <img src={detailData.icon} alt="" />
        </ContactIcon>
        <ContactName>{chatConfig.whatsappContactMsg}</ContactName>
        <ContactCode>
          <QRCode errorLevel="H" value={detailData.link} />
        </ContactCode>
        <ContactCodeTipsText>{chatConfig.whatsappQrcodeContactMsg}</ContactCodeTipsText>
        <ContactOpenButton
          onClick={() => {
            handleClickContactButton();
          }}
          $themeColor={chatConfig.chatThemeColor}
        >
          {chatConfig.whatsappOpenMsg}
        </ContactOpenButton>
      </ChatContainerDetail>
    );
  }

  const handleContainerContent = () => {
    // 判断container状态
    if (container === containerState.CONTACT) {
      return contactContent();
    } else if (container === containerState.CONTACT_DETAIL) {
      return contactDetailContent();
    }
  };

  return handleContainerContent();
});

const Plus = (color) => {
  return (
    <svg width="10" height="10" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M7.65429 3.37943H4.344V0.345143C4.34385 0.253701 4.30748 0.166044 4.24284 0.101358C4.17821 0.0366716 4.09058 0.000226592 3.99914 0C3.90775 0.000226312 3.82017 0.036632 3.75554 0.101256C3.69092 0.165881 3.65451 0.253465 3.65429 0.344857V3.37914H0.344857C0.253366 3.37937 0.165696 3.41585 0.101055 3.4806C0.0364144 3.54535 7.53327e-05 3.63308 0 3.72457C0.000226314 3.81596 0.036632 3.90355 0.101256 3.96817C0.165881 4.0328 0.253465 4.0692 0.344857 4.06943H3.65514V7.65514C3.65537 7.74654 3.69177 7.83412 3.7564 7.89874C3.82102 7.96337 3.90861 7.99977 4 8C4.09139 7.99977 4.17898 7.96337 4.2436 7.89874C4.30823 7.83412 4.34463 7.74654 4.34486 7.65514V4.06914H7.65514C7.74654 4.06892 7.83412 4.03251 7.89874 3.96789C7.96337 3.90326 7.99977 3.81568 8 3.72429C7.9994 3.63286 7.96276 3.54537 7.89803 3.4808C7.8333 3.41623 7.74571 3.3798 7.65429 3.37943Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_5017_35628">
          <rect width="8" height="8" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ChatContact;
